//-------------------------------------------------------------------------------------------------- Imports
import { Row, Col, Card, Typography } from "antd";
import { StyleSheet } from "../../StyleSheet";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import ListComponent, { ListComponentData } from "../../components/ListComponent";
import { useNavigate } from "react-router-dom";
import { images } from "../../routes/ImageRoutes";
const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- View
const ReferralSystem = () => {
    const navigate = useNavigate();
    const optionsArray: Array<ListComponentData> = [
        { title: "Compartir Código", subtitle: "" },
        { title: "Registrar Código", subtitle: "" },
        { title: "Reporte de descuentos aplicados", subtitle: "" },
    ];

    const goToRoute = (element: ListComponentData) => {
        switch (element.title) {
            case "Compartir Código":
                navigate('/referral-system/share-code')
                break;
            case "Registrar Código":
                navigate('/referral-system/register-code')
                break;
            case "Reporte de descuentos aplicados":
                navigate("/referral-system/report-discounts")
                break;
            default:
                break;
        }
    };

    return (
        <>
            <SubDefaultLayout title={"Refiere y Gana"}>
                <Row style={styles.rowCardPrincipal}>
                    <img
                        width="100%"
                        src={images.bannerReferidos}
                        alt="Recomienda Mega"
                        style={{ borderRadius: 25, marginBottom: 20 }}
                    />
                    <Col xs={16} xl={14}>
                        <Card
                            bodyStyle={{ justifyContent: "center" }}
                            style={{ ...styles.cardRoot }}
                        >
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                <div
                                    style={{
                                        ...styles.divRoot,
                                        backgroundColor: "#002f97",
                                    }}
                                >
                                    <Col style={{ marginTop: 15, marginBottom: 10 }}>
                                        <div>
                                            <Text style={styles.textPrincipal}>
                                                ¡Recomienda MEGA y Gana!
                                            </Text>
                                        </div>
                                        <div>
                                            <Text style={styles.textRegular}>
                                                Por cada persona que recomiendes y contrate <Text style={styles.textBold}>MEGA</Text>, recibirás en total <Text style={styles.textBold}>$300</Text> de descuento y tu referido <Text style={styles.textBold}>HBO</Text> gratis por 3 meses. <Text style={styles.textBold}>¡No lo dejes pasar!</Text>
                                            </Text>
                                        </div>
                                    </Col>
                                </div>
                            </Row>
                        </Card>
                    </Col>
                    <Col xs={16} xl={14}>
                        <ListComponent
                            arrayList={optionsArray}
                            onPress={(option: ListComponentData) => goToRoute(option)}
                        />
                    </Col>
                </Row>
            </SubDefaultLayout>
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    rowCardPrincipal: {
        marginTop: 25,
        display: 'flex',
        justifyContent: 'center',
    },
    cardRoot: {
        backgroundColor: "white",
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20,
    },
    divRoot: {
        width: "100%",
        borderRadius: 18,
        display: "flex",
        textAlign: "center",
        justifyContent: "center",
    },
    textPrincipal: {
        color: "white",
        fontSize: 20,
        fontWeight: 600,
    },
    textRegular: {
        color: "white",
        fontSize: 15,
    },
    textBold: {
        color: "white",
        fontSize: 15,
        fontWeight: 600,
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ReferralSystem;
